import { ReactNode } from 'react';

import { cn } from 'styles';

interface ActionTitleProps {
  className?: ReactNode;
  children: ReactNode;
}

export function ActionTitle({ children, className }: ActionTitleProps) {
  return (
    <h3 className={cn('text-sm font-semibold text-muted-foreground', className)}>
      <>{children}</>
    </h3>
  );
}
